module.exports = __webpack_public_path__ + "img/arrow.81b9c3e2.svg";